import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {IStock} from '../../shared/model/stock.model';
import {StockService} from './stock.service';
import {ModalDismissReasons, NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgxSpinnerService} from 'ngx-spinner';
import {AccountService} from '../../singelton/account.service';
import * as moment from 'jalali-moment';
import {StockUpdateComponent} from "./stock-update.component";
import {StockHistoryComponent} from "./stock-history.component";
import {INote} from "../../shared/model/note.model";
import {CalendarService} from "../calendar/calendar.service";

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.scss']
})
export class StockComponent implements OnInit, OnDestroy {
  @Input() mode;
  @Input() status;
  @Input() type;
  currentAccount: any;
  stocks: IStock[];
  filterTerm: string = '';
  error: any;
  success: any;
  eventSubscriber: Subscription;
  routeData: any;
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  closeResult: string;
  currentDate: INote;
  h_temp: any;
  width: any = '100%';

  constructor(protected stockService: StockService,
              protected accountService: AccountService,
              protected calendarService: CalendarService,
              private modalService: NgbModal,
              public activeModal: NgbActiveModal,
              protected activatedRoute: ActivatedRoute,
              protected router: Router,
              private spinner: NgxSpinnerService) {
    this.itemsPerPage = 20;
    this.page = 1;
    this.predicate = 'id';
    this.reverse = 'asc';

  }

  loadAll() {

    this.spinner.show();
    this.accountService.identity().then(account => {
      // alert(' in account ==' + account.id);
      const employeeId = account.id;
      const pageSize = this.mode === 'popup' ? 200 : this.itemsPerPage;

      this.stockService.query(
        {
          page: this.page - 1,
          size: pageSize,
          sort: this.sort(this.predicate, this.reverse)
        }
      ).subscribe(
        // this.stockService.findMyStock(employeeId).subscribe(
        (res: HttpResponse<IStock[]>) => {
          this.stocks = res.body;
          this.spinner.hide();

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    });
    // this.stockService
    //   .query({
    //     page: this.page - 1,
    //     size: this.itemsPerPage,
    //     sort: this.sort(this.predicate, this.reverse)
    //   })
    //   .subscribe(
    //     (res: HttpResponse<IStock[]>) => this.paginateStocks(res.body, res.headers),
    //     (res: HttpErrorResponse) => this.onError(res.message)
    //   );
  }

  loadPage(page: number) {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.transition();
    }
  }

  numberWithCommas(x) {

    if(x)
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');

    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) {
      x = x.replace(pattern, '$1,$2');
    }
    return x;

  }

  loadPage2(param) {
    if (this.predicate === param) {
      if (this.reverse === 'asc') {
        this.reverse = 'desc';
      } else {
        this.reverse = 'asc';
      }
    } else {
      this.reverse = 'asc';
    }
    this.predicate = param;
    this.transition();
  }


  transition() {
    this.loadAll();
  }


  parseDate(value) {
    let jalaliDate5 = '-';
    if (value) {
      jalaliDate5 = moment(new Date(value)).locale('fa').format('jYYYY/jM/jD');
    }
    return jalaliDate5;
  }


  clear() {
    this.activeModal.dismiss('cancel');

  }

  ngOnInit() {
    this.loadAll();
    this.registerChangeInStocks();
    this.getCurrentDate();
  }

  getCurrentDate() {
    let temp = '';


    this.calendarService
      .getCurrentDate()
      .subscribe(
        (res: HttpResponse<any>) => {
          this.currentDate = res.body;
          this.h_temp = this.currentDate.description.split(' ')[1];

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );

  }

  ngOnDestroy() {
    // this.eventManager.destroy(this.eventSubscriber);
  }

  trackId(index: number, item: IStock) {
    return item.id;
  }

  registerChangeInStocks() {
    // this.eventSubscriber = this.eventManager.subscribe('stockListModification', response => this.loadAll());
  }

  sort(predicate, reverse) {
    let result = ['id, desc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }


  protected paginateStocks(data: IStock[], headers: HttpHeaders) {
    // this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.stocks = data;
  }

  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  //
  // open() {
  //   this.modalService.open(SelfStockUpdateComponent).result.then((result) => {
  //     this.closeResult = `Closed with: ${result}`;
  //     // alert(' in 00000');
  //
  //   }, (reason) => {
  //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //     // alert(' in 1111');
  //     this.loadAll();
  //   });
  // }


  open() {

    const modalRef = this.modalService.open(StockUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
    // modalRef.componentInstance.type = 'Task';
    // modalRef.componentInstance.customerId = this.customer.id;

    modalRef.result.then(
      res => {
        this.loadAll();
      },
      rejected => {
        this.loadAll();
      }
    );

  }

  editStock(id) {
    const modalRef = this.modalService.open(StockUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
    modalRef.componentInstance.stockEdit = id;
    // modalRef.componentInstance.customerId = this.customer.id;
    modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.loadAll();
      }
    );
  }

  showHistory(stock: IStock) {
    const modalRef = this.modalService.open(StockHistoryComponent, {
      windowClass: 'lg',
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.stock = stock;
    modalRef.componentInstance.stockId = stock && stock.id;
  }


  parseDateJalali(value) {
    let jalaliDate5 = '-';
    if (value) {
      jalaliDate5 = moment(new Date(value)).locale('fa').format('jYYYY/jM/jD');
    }
    return jalaliDate5;
  }


  // deleteStock(id) {
  //   const modalRef = this.modalService.open(StockDeleteDialogComponent, {windowClass: 'lg', backdrop: 'static'});
  //   modalRef.componentInstance.stockEdit = id;
  //   modalRef.result.then(
  //     (result) => {
  //       this.closeResult = `Closed with: ${result}`;
  //     }, (reason) => {
  //       this.loadAll();
  //     }
  //   );
  // }

  // editStock(id) {
  //   const modalRef = this.modalService.open(SelfStockUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
  //   // alert('  befor send id =' + id);
  //   modalRef.componentInstance.stockEdit = id;
  //   // callback of the popup
  //   modalRef.result.then(
  //     (result) => {
  //       this.closeResult = `Closed with: ${result}`;
  //       // alert(' in 00000');
  //
  //     }, (reason) => {
  //       this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //       // alert(' in 1111');
  //       this.loadAll();
  //     }
  //     //   res => {
  //     //   console.log(res + ' the result of popup');
  //     //   this.loadAll();
  //     // }, rejected => {
  //     //   console.log(' rejected: ' + rejected.toString());
  //     //   this.loadAll();
  //     // }
  //
  //   );
  //
  //
  // }
  //
  // deleteStock(id) {
  //   const modalRef = this.modalService.open(StockDeleteDialogComponent, {windowClass: 'lg', backdrop: 'static'});
  //   // alert('  befor send documentType =' + this.documentType);
  //   modalRef.componentInstance.stockEdit = id;
  //   // callback of the popup
  //   modalRef.result.then(
  //     (result) => {
  //       this.closeResult = `Closed with: ${result}`;
  //       // alert(' in 00000');
  //
  //     }, (reason) => {
  //       this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //       // alert(' in 1111');
  //       this.loadAll();
  //     }
  //     //   res => {
  //     //   console.log(res + ' the result of popup');
  //     //   this.loadAll();
  //     // }, rejected => {
  //     //   console.log(' rejected: ' + rejected.toString());
  //     //   this.loadAll();
  //     // }
  //
  //   );
  //
  //
  // }


  percentCellRenderer
  (value, count, alarm_point_count, order_point_count) {
    // alert(' in percentCellRenderer=');

    let temp = '';
    // const today = new Date();
    const today = new Date(this.currentDate.description);

    if (value) {
      var h_value: any[] = value.split('T');
      value = h_value[0] + ' ' + this.h_temp;
    }
    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }
    // alert('today='+today);
    // alert('tdateExpiration='+dateExpiration);

    // alert('timeDiff='+timeDiff);

    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    // alert('diffDays='+diffDays);


    value = diffDays;
    let valueNumber = Number(value + '');
    let valueStr = '';
    const eDivPercentBar = document.createElement('div');
    eDivPercentBar.className = '';
    const eValue = document.createElement('div');
    valueStr = 'Expired';
    const diff_count_order = Number(count + '') - Number(order_point_count);
    const diff_count_alarm = Number(count + '') - Number(alarm_point_count);

    eValue.className = 'progress-bar progress-bar-striped bg-primary';
    // alert('value='+value);
    // alert('alarm_point_count='+alarm_point_count);

    // alert('111111 valueNumber='+valueNumber);
    valueNumber= valueNumber+1;
    // alert('222222 valueNumber='+valueNumber);
    // alert('valueNumber > 0='+Number(valueNumber) > 0);
    // alert('valueNumber >= 0='+Number(valueNumber) >= 0);
    // alert('valueNumber <= 0='+Number(valueNumber) <= 0);
    // alert('valueNumber < 0='+Number(valueNumber) < 0);
    // alert('valueNumber === 0='+Number(valueNumber) === 0);
    // alert('valueNumber == 0='+Number(valueNumber) ==
    //   0);
    // alert('diff_count_alarm='+diff_count_alarm);

    if (order_point_count && alarm_point_count && value) {
  // alert(' in if 1');
      if (diff_count_alarm < 0 && diff_count_order > 0) {
        valueStr = 'نرمال';
        eValue.style.width = '100%';
        eValue.style.paddingLeft = '1px';
        eValue.style.color = 'green';

      } else if (diff_count_order <= 0) {
        eValue.style.width = '100%';
        valueStr = 'نقطه سفارش';
        eValue.className = 'progress-bar progress-bar-striped bg-primary';
      } else if (Number(valueNumber) <= 0 && diff_count_alarm >= 0) {
        eValue.style.width = '100%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        // valueStr = '' + Math.abs(value) + ' روز گذشته';
        valueStr = 'کالای مانده';

      } else {
        eValue.style.width = '0%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        // valueStr = '' + Math.abs(value) + ' روز گذشته';
        valueStr = '';

      }
    } else if (order_point_count ) {
      // alert(' in else if 2');

      if (diff_count_order > 0) {
        valueStr = 'نرمال';
        eValue.style.width = '100%';
        eValue.style.paddingLeft = '1px';
        eValue.style.color = 'green';

      } else if (diff_count_order <= 0) {
        eValue.style.width = '100%';
        valueStr = 'نقطه سفارش';
        eValue.className = 'progress-bar progress-bar-striped bg-primary';
      }
      } else if (alarm_point_count && value) {
      // alert(' in else if 3');

      // alert('value='+value);
      // alert('alarm_point_count='+alarm_point_count);

      if (Number(valueNumber) <= 0 && diff_count_alarm >= 0) {
        // alert('valueNumber='+Number(valueNumber));
        // alert('diff_count_alarm='+diff_count_alarm);

        eValue.style.width = '100%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        // valueStr = '' + Math.abs(value) + ' روز گذشته';
        valueStr = 'کالای مانده';


      }
      else {
        valueStr = 'نرمال';
        eValue.style.width = '100%';
        eValue.style.paddingLeft = '1px';
        eValue.style.color = 'green';

      }
      } else {
      // alert(' in else 3');

      eValue.style.width = '0%';
      eValue.className = 'progress-bar progress-bar-striped bg-danger';
      // valueStr = '' + Math.abs(value) + ' روز گذشته';
      valueStr = '';

    }

    const eOuterDiv = document.createElement('div');
    eOuterDiv.className = 'progress mb-2';
    eOuterDiv.style.marginTop = '12px';
    eOuterDiv.appendChild(eValue);
    const re = /&lt;/gi;
    const re2 = /&gt;/gi;
    const str = eOuterDiv.outerHTML;
    const newstr = str.replace(re, '<').replace(re2, '>');
    const newstr2 = str.replace(re, '>');
    return valueStr;
  }

  styleObject
  (value, count, alarm_point_count, order_point_count): Object {

    const diff_count_order = Number(count + '') - Number(order_point_count);
    const diff_count_alarm = Number(count + '') - Number(alarm_point_count);

    const today = new Date(this.currentDate.description);

    if (value) {
      var h_value: any[] = value.split('T');
      value = h_value[0] + ' ' + this.h_temp;
    }

    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    value = diffDays;


    let valueNumber = Number(value + '');
    // alert('111111 valueNumber='+valueNumber);
    valueNumber= valueNumber+1;
    // alert('222222 valueNumber='+valueNumber);

    if (order_point_count && alarm_point_count && value) {

    if (diff_count_alarm < 0 && diff_count_order > 0) {
      this.width = '100%';
      return {width: this.width, 'background-color': '#168016'};

    } else if (diff_count_order <= 0) {
      this.width = '100%';
      return {width: this.width, 'background-color': '#f6ab20'};

    } else if (Number(valueNumber) <= 0 && diff_count_alarm >= 0) {
      this.width = '100%';
      return {width: this.width, 'background-color': '#dc3545'};

    } else {
      this.width = '0%';

      return {width: this.width, 'background-color': '#dc3545'};


    }
    } else if (order_point_count ) {

      if ( diff_count_order > 0) {
        this.width = '100%';
        return {width: this.width, 'background-color': '#168016'};

      } else if (diff_count_order <= 0) {
        this.width = '100%';
        return {width: this.width, 'background-color': '#f6ab20'};

          }

    } else if (alarm_point_count && value) {
     if (Number(valueNumber) <= 0 && diff_count_alarm >= 0) {
        this.width = '100%';
        return {width: this.width, 'background-color': '#dc3545'};

       } else {
       this.width = '100%';
       return {width: this.width, 'background-color': '#168016'};

     }

    }else{
           this.width = '0%';

        return {width: this.width, 'background-color': '#dc3545'};




    }
  }

  showStore(val) {
    this.router.navigate(['/page/store/' + val]);
    this.clear();

  }

  get filteredStocks(): IStock[] {
    if (!this.stocks) {
      return [];
    }
    const q = (this.filterTerm || '').trim().toLowerCase();
    if (!q) {
      return this.stocks;
    }
    return this.stocks.filter(s => {
      const title = s.kala && s.kala.title ? String(s.kala.title).toLowerCase() : '';
      const code = s.code ? String(s.code).toLowerCase() : '';
      const store = s.store && s.store.title ? String(s.store.title).toLowerCase() : '';
      const kalaCode = s.kala && (s.kala as any).code ? String((s.kala as any).code).toLowerCase() : '';
      return title.indexOf(q) >= 0 || code.indexOf(q) >= 0 || store.indexOf(q) >= 0 || kalaCode.indexOf(q) >= 0;
    });
  }

  canSelectStock(stock: IStock): boolean {
    if (!stock) {
      return false;
    }
    const count = stock.count != null ? Number(stock.count) : 0;
    if (this.type === 'rent') {
      const okStatus = this.status === 'created' || this.status === 'approved'
        || this.status === 'pre_invoice' || this.status === 'confirmed';
      if (!okStatus) {
        return count >= 1;
      }
      return true;
    }
    // فروش کالا: فقط موجودی مثبت
    return count >= 1;
  }

  selectStock(id) {
    // alert(' in selectCustomer ==' + id);
    this.activeModal.dismiss(id);

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
